module.exports = __webpack_public_path__ + "img/atlas-logo.b113b7c0.png";